const common = {
  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  },
  getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  },
  formatRoomText(b, u, r) {
    let building = b.toString()
    let unit = u.toString()
    let room = r.toString()
    if (building.length == 2) {
      building = `0${building}`
    } else if (building.length == 1) {
      building = `00${building}`
    }
    if (unit.length == 1) {
      unit = `0${unit}`
    }
    if (room.length == 3) {
      room = `0${room}`
    } else if (room.length == 2) {
      room = `00${room}`
    } else if (room.length == 1) {
      room = `000${room}`
    }
    return `${building}座${unit}门${room}室`
  },
  getDateTime(timeStamp, format) {
    if (!timeStamp) {
      return ''
    }
    let date = new Date();
    date.setTime(timeStamp * 1000);
    let Y = date.getFullYear();
    let M = date.getMonth() + 1;
    M = M < 10 ? `0${M}` : M;
    let D = date.getDate();
    D = D < 10 ? `0${D}` : D;
    let h = date.getHours();
    h = h < 10 ? `0${h}` : h;
    let m = date.getMinutes();
    m = m < 10 ? `0${m}` : m;
    let s = date.getSeconds();
    s = s < 10 ? `0${s}` : s;
    if (!format) {
      format = 'YYMMDDhhmm'
    }
    switch (format) {
      case 'YYMMDDhhmmss':
        return `${Y}/${M}/${D} ${h}:${m}:${s}`
        break;
      case 'YYMMDDhhmm':
        return `${Y}/${M}/${D} ${h}:${m}`
        break;
      case 'YYMMDD':
        return `${Y}/${M}/${D}`
        break;
      case 'MMDD':
        return `${M}/${D}`
        break;
      case 'hhmm':
        return `${h}:${m}`
        break;
    }
  },
  getUserAgent(){
    var browser = {
      versions: function () {
        var u = navigator.userAgent, app = navigator.appVersion;
        return {
          trident: u.indexOf('Trident') > -1, //IE内核
          presto: u.indexOf('Presto') > -1, //opera内核
          webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
          iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
          iPad: u.indexOf('iPad') > -1, //是否iPad
          webApp: u.indexOf('Safari') == -1, //是否web应用程序，没有头部与底部
          qt: u.indexOf('qtwebengine') > -1
        };
      }(),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }
    if (browser.versions.mobile) {//判断是否是移动设备打开。browser代码在下面
      return 'mobile'
      // var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
      // if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //   return 'Weixin'
      // }
      // if (ua.match(/WeiBo/i) == "weibo") {
      //   return 'Weibo'
      // }
      // if (ua.match(/QQ/i) == "qq") {
      //   return 'QQ'
      // }
      // if (browser.versions.ios) {
      //   return 'IOS'
      // }
      // if (browser.versions.android){
      //   return 'Android'
      // }
    } else if (browser.versions.iPad) {
      return 'iPad'
    } else if (browser.versions.qt) {
      return 'QT'
    } else {
      return 'PC'
    }
  },
  IEVersion() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if(isIE) {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      reIE.test(userAgent);
      var fIEVersion = parseFloat(RegExp["$1"]);
      if(fIEVersion == 7) {
        return 7;
      } else if(fIEVersion == 8) {
        return 8;
      } else if(fIEVersion == 9) {
        return 9;
      } else if(fIEVersion == 10) {
        return 10;
      } else {
        return 6;//IE版本<=7
      }
    } else if(isEdge) {
      return 'edge';//edge
    } else if(isIE11) {
      return 11; //IE11
    }else{
      return -1;//不是ie浏览器
    }
  },
  invokeApp(fun, param){
    let dev = common.getUserAgent()
    let data = param ? JSON.stringify(param) : null
    let androidFunName = null
    let iosFunName = null
    switch (fun) {
      case 'goback':
        androidFunName = 'goback'
        iosFunName     = 'iosGoBack'
        break;
      case 'logout':
        androidFunName = 'logout'
        iosFunName     = 'logout'
        break;
      default:
    }
    if (dev == "IOS" && iosFunName){
      window.webkit.messageHandlers[iosFunName].postMessage(data)
    } else if (dev == "Android" && androidFunName) {
      document.location = `js://${androidFunName}?param=${data}`
    }
  },
  stopPropagation(e){
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      e.cancelBubble = true;
    }
  },
}

export default common
